<template>
    <div>
        <Menu as="div" class="relative inline-block text-left">
            <div>
                <MenuButton
                    class="border bg-interactive-9 p-2 text-gray-700 hover:bg-gray-50 focus:ring-0 connect-btn rounded focus:outline-none font-normal min-w-[60px] flex justify-center items-center">
                    <img src="@/assets/icons/settings.svg" class="w-4 h-4" alt="settings"/>
                </MenuButton>
            </div>
            <transition enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="origin-top-right absolute xxs:left-auto xxs:right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none">
                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }"
                                  @click="showOrganizationSettings = true; currentStep = 1">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/edit-pencil.svg" class="w-4 h-3 mr-4" alt="edit"/>
                                Rename organization
                            </div>
                        </MenuItem>
                    </div>
                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }"
                                  @click.stop="router.push({ name: 'theme-settings' })">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/done-circle.svg" class="w-4 h-4 mr-4" alt="check"/>
                                Choose organization color
                            </div>
                        </MenuItem>
                    </div>
                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }"
                                  @click="showOrganizationSettings = true; currentStep = 2">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/camera.svg" class="w-4 h-4 mr-4" alt="camera"/>
                                Change organization logo
                            </div>
                        </MenuItem>
                    </div>
                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }"
                                  @click="showOrganizationSettings = true; currentStep = 3">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/image.svg" class="w-4 h-4 mr-4" alt="image"/>
                                Change organization cover
                            </div>
                        </MenuItem>
                    </div>
                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }" @click="emit('showCoverTextColorModal')">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/picker.svg" class="w-4 h-4 mr-4" alt="image"/>
                                Change cover text color
                            </div>
                        </MenuItem>
                    </div>

                    <div class="py-1">
                        <MenuItem as="div" v-slot="{ active }" @click="router.push({name: 'reorder-dashboard'})">
                            <div
                                :class="[active ? '' : 'text-gray-700', 'group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 hover:cursor-pointer']">
                                <img src="../../assets/icons/image.svg" class="w-4 h-4 mr-4" alt="image"/>
                                Reorder widgets
                            </div>
                        </MenuItem>
                    </div>

                </MenuItems>
            </transition>
        </Menu>
        <Modal v-model:show="showOrganizationSettings" :ignore-click-outside="false"
               @close="showOrganizationSettings = false">
            <DashboardSettings :current-step="currentStep" type="update" @close="showOrganizationSettings = false"/>
        </Modal>
    </div>
</template>
<script setup>
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import DashboardSettings from "@/components/modals/partials/DashboardSettings.vue";
import {ref} from "vue";
import Modal from "@/components/core/Modal.vue";
import {useRouter} from "vue-router";

const router = useRouter();
const showOrganizationSettings = ref(false);
const currentStep = ref(0);

const emit = defineEmits(['showCoverTextColorModal'])
</script>
